import { createFileRoute, Outlet } from "@tanstack/react-router";
import Layout from "@/app/[tenantId]/[messengerId]/[hostConfig]/layout";
import initPage from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/utils/initPage";
import GenericErrorRetry from "@/components/GenericErrorRetry";
import { useApi } from "@/lib/client/hooks/useApi";
import { useMemo } from "react";
import { getDecodedMessengerToken, parseHostPageConfig } from "@/lib/client/utils/config";
import { SessionProvider } from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/contexts/SessionContext";
import DeviceContext from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/contexts/DeviceContext";

export const Route = createFileRoute("/$tenantId/$messengerId/$hostConfig/_launcherLayout")({
  component: Component,
  errorComponent: GenericErrorRetry,
});

function Component() {
  const params = Route.useParams();

  const config = parseHostPageConfig(params.hostConfig);
  const messengerToken = config?.messengerToken || "";
  const platform = config?.platform || "WEB";

  return (
    <DeviceContext
      name={`dp-messenger-state${
        getDecodedMessengerToken(messengerToken)?.iss === "admin-api" ? "-admin-preview" : ""
      }-${params.tenantId}`}
      platform={platform}
    >
      <SessionProvider>
        <Initialized />
      </SessionProvider>
    </DeviceContext>
  );
}

function Initialized() {
  const params = Route.useParams();
  const args: Parameters<typeof initPage> = useMemo(() => {
    return [
      {
        tenantId: params.tenantId,
        messengerId: params.messengerId,
        hostConfig: params.hostConfig,
      },
    ];
  }, [params.tenantId, params.messengerId, params.hostConfig]);

  const { data, error } = useApi(initPage, {
    args,
  });

  if (error) {
    return <div></div>;
  }

  if (!data) return null;

  return (
    <Layout
      params={params}
      config={data.config}
      mediaBaseUrl={data.mediaBaseUrl}
      basePath={data.basePath}
      platform={data.platform}
    >
      <Outlet />
    </Layout>
  );
}
